import { getEditableField } from '../store/selectors';
export var validateImages = function (params) {
    var store = params.store;
    var state = store.getState();
    var isValid = true;
    var errors = [];
    var coverImage = getEditableField(state, 'emailCoverImage').value;
    var sendEmail = getEditableField(state, 'sendEmail').value;
    if (!coverImage && sendEmail) {
        isValid = false;
        errors.push({ field: 'emailCoverImage', message: 'Image is required' });
    }
    return {
        isValid: isValid,
        errors: errors,
    };
};
